import React, { useEffect } from 'react';
import PasswordResetsPage from './password-resets/PasswordResetsPage';
import './users/users.css';
import './users/brand.css';
import './password-resets/resets.css';
export default function PasswordResetManagement() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <PasswordResetsPage />;
}
